import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Paper from '@base/Paper/Paper';
import Skeleton from '@material-ui/lab/Skeleton';
import { Spacings } from '../../../styleConstants';

const WeekInfoWrapper = styled.div`
  grid-column: 2/9;
  position: sticky;
  top: 235px;
  opacity: ${({ isEducatorSide, notAccessible }) =>
    isEducatorSide ? 1 : notAccessible && 0.5};
`;

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(24, 1fr);
  grid-column-gap: ${Spacings.SPACING_4B};
  grid-column: span 24;
  margin-top: ${({ isBatch, showMargin = true }) =>
    showMargin && (isBatch ? Spacings.SPACING_16B : Spacings.SPACING_10B)};
  margin-bottom: ${({ mb = false }) =>
    mb ? Spacings.SPACING_10B : Spacings.SPACING_0B};
  position: relative;
`;

const StyledContent = styled(Paper)`
  grid-column: 9/25;
  height: 100px;
  padding: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Play = styled.div``;

const PlayIcon = styled(Skeleton)`
  width: 40px;
  height: 40px;
  margin-right: 24px;
  margin-bottom: 8px;
`;

const Description = styled.div`
  width: 100%;
  height: 100%;
`;

const Title = styled(Skeleton)`
  margin-bottom: 8px;
`;

const weeks = { week1: [1], week2: [1, 2, 3], week3: [1, 2, 3] };

const Week = ({ index }) => {
  return (
    <Wrapper>
      {index === 1 && (
        <WeekInfoWrapper>
          <Skeleton variant="rect" width="50%" height="15px" />
          <Skeleton variant="text" width="75%" />
        </WeekInfoWrapper>
      )}
      <StyledContent>
        <Play>
          <PlayIcon variant="circle" />
          <Skeleton variant="rect" width="50%" height="5px" />
        </Play>
        <Description>
          <Title variant="text" width="75%" />
          <Skeleton variant="text" width="75%" />
        </Description>
      </StyledContent>
    </Wrapper>
  );
};

Week.propTypes = {
  index: PropTypes.number.isRequired
};

const Weeks = () => {
  const { week1, week2, week3 } = weeks;
  const renderWeeks = (info, mb = false, type) => (
    <Wrapper showMargin={false} mb={mb} type={type}>
      {info.map((week) => (
        <Week key={week} index={week} />
      ))}
    </Wrapper>
  );
  return (
    <>
      {renderWeeks(week1, true, 'week1')}
      {renderWeeks(week2, true, 'week2')}
      {renderWeeks(week3, true, 'week3')}
    </>
  );
};

export default Weeks;
